import { channels } from "@/mocks/kanliao";

export default function Channels() {
  return (
    <section id="channels" className="relative overflow-hidden bg-primary-950 py-16 md:py-24">
      <div
        className="pointer-events-none absolute -top-24 right-0 h-72 w-72 rounded-full bg-primary-700/30 blur-3xl"
        aria-hidden="true"
      ></div>
      <div
        className="pointer-events-none absolute bottom-0 left-10 h-72 w-72 rounded-full bg-accent-900/40 blur-3xl"
        aria-hidden="true"
      ></div>

      <div className="container-px relative">
        <div className="flex max-w-2xl flex-col items-center text-center md:mx-auto">
          <span className="section-title !text-primary-300">订阅来源</span>
          <h2 className="mt-4 font-heading text-2xl font-bold text-background-50 md:text-4xl">
            丰富来源，随心订阅
          </h2>
          <p className="mt-4 text-sm leading-7 text-white/70 md:text-base">
            站点栏目、作者主页、话题关键词……只要是会更新内容的地方，都可以纳入你的订阅清单，
              统一通过推送通知触达。
          </p>
        </div>

        <ul className="mt-12 grid grid-cols-2 gap-3 sm:grid-cols-4 md:gap-4">
          {channels.map((channel) => (
            <li
              key={channel.label}
              className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/[0.06] px-4 py-4 text-background-50 backdrop-blur-sm transition-colors hover:border-primary-400 hover:bg-white/10"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent-500/90 text-background-50">
                <i className={`${channel.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <span className="text-sm font-medium md:text-base">{channel.label}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}